import React, { ReactNode } from 'react';

export const pinnedSurveyContent = (
  fillChrome: ReactNode | null,
  confirmStrip: ReactNode | null,
): ReactNode | undefined => {
  if (!fillChrome && !confirmStrip) {
    return undefined;
  }
  return (
    <>
      {fillChrome}
      {confirmStrip}
    </>
  );
};
